import gql from 'graphql-tag';

export const GET_FINANCE_SERVICES_WITH_QUERY = gql`
	query GetFinanceServices($query: JSON, $regionId: String, $limit: Int, $offset: Int, $order: [[String]]) {
		services(query: $query, regionId: $regionId, limit: $limit, offset: $offset, order: $order) {
			id
			agentNotes
			address
			regionalManagerNotes
			status
			type
			property {
				id
				unitNumber
				address
				alias
				city
				country
				state
				streetAddress
				timezone
				zipCode
			}
			region {
				name
			}
			orderInformation
			serviceDate
			surgeBoost
			bookedOptions {
				id
				name
				price
				quantity
				packageType
				photographerPay
				additionalInfo
				additionalInfoType
			}
			isDroneService
			isTraining
			client {
				id
				email
				phoneNumber
				name
				notes
				image
			}
			photographer {
				id
				name
				email
				stripeAccountId
				phoneNumber
				image
			}
			stripeBookingTotal
		}
	}
`;
